import React from 'react';

import { ModalStyled } from 'components/UI/styled/modal-styled';
import { ButtonStyled } from 'components/UI/styled/button-styled';
import {cpfMask} from "../../utils/cpf-utils";
import {getFormattedDate} from "../../utils/date-utils";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  message: string;
  title?: string;
  cpf?: string;
  bolsaCurso?: string;
  nome?: string;
  data?: Date;
}
const AlertModal = (props: Props) => {
  const htmlText = { __html: props.message };

  return (
    <ModalStyled
      show={props.isOpen}
      onHide={props.onClose}
      className="modal-md"
    >
      <ModalStyled.Header closeButton className="warning">
        <ModalStyled.Title>{props.title}</ModalStyled.Title>
      </ModalStyled.Header>

      <ModalStyled.Body>
        <div className="simple-text" dangerouslySetInnerHTML={htmlText} />
        {props.bolsaCurso &&
        <div>
          <label>Convênio:</label> <span>{props?.bolsaCurso}</span>
        </div>
        }
        {props.cpf &&
          <div>
            <label>CPF:</label> <span>{cpfMask(props?.cpf)}</span>
          </div>
        }
        {props.nome &&
          <div>
            <label>Nome:</label> <span>{props?.nome}</span>
          </div>
        }
        {props.data &&
          <div>
            <label>Data de Indicação:</label> <span>{getFormattedDate(props?.data)}</span>
          </div>
        }
      </ModalStyled.Body>

      <ButtonStyled className="right" onClick={() => props.onClose()}>
        Fechar
      </ButtonStyled>
    </ModalStyled>
  );
};

export default AlertModal;
